module.exports = __webpack_public_path__ + "img/votronic_12_100.fe111856.png";